import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import { getTranslatedText as translate } from "../../Localization/Translation";

const useSearchWasher = () => {
  const { locale, setSelectedLaundryIndex } = useBetween(
    useSelector((state) => state.useSharedState)
  );
  const AllCities = useSelector((state) => state.AllCities);
  const Launds = useSelector((state) => state.AllLaunds);

  const [SearchValue, setSearchValue] = useState("");
  const [cityValue, setCityValue] = useState("choose-city");
  const [sortValue, setSortValue] = useState("sort-starting-with");
  const [LastLaundromats, setLastLaundromats] = useState(Launds);
  const [show, setShow] = useState(false);

  //   Launds List
  let d = "-1";
  var LaundCards = LastLaundromats.length ? (
    LastLaundromats.map((Laund, index) => {
      d = Number(d) + 1;

      return (
        <div
          className={
            "Laund-item-list col-1 animate__animated animate__fadeInLeft animate__delay-" +
            d +
            "s"
          }
          key={Laund.id}
          onClick={() => handleShow(index)}
        >
          <div className=" Laund-item-card-list">
            <div className="card border-radius">
              <div
                className="card-body card-body-laund"
                dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
              >
                <div dir={locale === "EN" || locale === "HN" ? "rtl" : "ltr"}>
                  {Laund.freeDelivery || Laund.discount ? (
                    <div className="card-offer">
                      {Laund.freeDelivery ? (
                        <span>
                          <i className="bi bi-truck"></i>
                          <span>{translate("free-deliver-label", locale)}</span>
                        </span>
                      ) : (
                        ""
                      )}
                      {Laund.freeDelivery && Laund.discount ? " + " : ""}
                      {Laund.discount ? (
                        <span>
                          <span>{translate("discount-label", locale)}</span>{" "}
                          <span>(50%)</span>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="card-padding">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="card-title-laund">
                      <h5 className="card-title card-title-laund">
                        {Laund.name}
                      </h5>
                      <p className="card-text card-fav-icon">
                        {Laund.fav === true ? (
                          <i className="bi bi-heart-fill like-icon-rate"></i>
                        ) : (
                          <i className="bi bi-heart like-icon-rate"></i>
                        )}
                      </p>
                    </div>
                    <div className="card-title-laund">
                      <p className="card-text card-star-icon">
                        <span>{Laund.rate}</span>
                        <i className="bi bi-star-fill star-icon-rate"></i>
                      </p>
                    </div>
                  </div>

                  <hr />

                  <p
                    className="card-text card-text-laund"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title={Laund.locate}
                  >
                    <span>
                      {translate("laundry-location-label-card", locale)}
                    </span>
                    {Laund.locate.slice(0, 50)}
                    {Laund.locate.length > 50 ? "..." : ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    })
  ) : (
    <div className="no-laundromats animate__animated animate__fadeIn">
      <i className="bi bi-emoji-frown"></i>
      {translate("no-laundromats", locale)}
    </div>
  );

  //   Functions
  useEffect(() => {
    setLastLaundromats(
      Launds.filter(checkCity)
        .filter(checkSearch)
        .sort((a, b) => {
          let da = a.rate,
            db = b.rate;
          if (sortValue === "sort-starting-with") return true;
          else if (sortValue === "more-to-less") return db - da;
          else if (sortValue === "less-to-more") return da - db;
          return false;
        })
    );
  }, [SearchValue, cityValue, sortValue]);

  const handleClose = () => setShow(false);
  const handleShow = (laundryIndex) => {
    setSelectedLaundryIndex(laundryIndex);
    setShow(true);
  };

  const selectCityChange = (e) => setCityValue(e.target.value);
  const searchBoxChange = (e) => setSearchValue(e.target.value);
  const selectSortChange = (e) => setSortValue(e.target.value);

  function checkCity(item) {
    if (cityValue === "choose-city") return true;
    else if (item.locate === cityValue) return true;
    return false;
  }
  function checkSearch(item) {
    if (item.name.startsWith(SearchValue, 0)) return true;
    return false;
  }

  return {
    locale,
    AllCities,
    LaundCards,
    show,

    // functions
    handleClose,
    selectCityChange,
    searchBoxChange,
    selectSortChange,
  };
};

export default useSearchWasher;
